import { emptySplitApi as api } from "./emptyApi"
import {
  KeyEventControllerCreateKeyEventApiResponse,
  KeyEventControllerCreateKeyEventApiArg,
  KeyEventControllerGetAllKeyEventsApiResponse,
  KeyEventControllerGetAllKeyEventsApiArg,
  KeyEventControllerUpdateKeyEventApiResponse,
  KeyEventControllerUpdateKeyEventApiArg,
  KeyEventControllerDeleteKeyEventApiResponse,
  KeyEventControllerDeleteKeyEventApiArg,
} from "./types/key-events.types"

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    keyEventControllerGetAllKeyEvents: build.query<
      KeyEventControllerGetAllKeyEventsApiResponse,
      KeyEventControllerGetAllKeyEventsApiArg
    >({
      query: () => ({ url: `/key-event` }),
      providesTags: ["KeyEvents"],
    }),
    keyEventControllerCreateKeyEvent: build.mutation<
      KeyEventControllerCreateKeyEventApiResponse,
      KeyEventControllerCreateKeyEventApiArg
    >({
      query: queryArg => ({
        url: `/key-event`,
        method: "POST",
        body: queryArg.createKeyEventDto,
      }),
      invalidatesTags: ["KeyEvents"],
    }),
    keyEventControllerUpdateKeyEvent: build.mutation<
      KeyEventControllerUpdateKeyEventApiResponse,
      KeyEventControllerUpdateKeyEventApiArg
    >({
      query: queryArg => ({
        url: `/key-event/${queryArg.id}`,
        method: "PUT",
        body: queryArg.updateKeyEventDto,
      }),
      invalidatesTags: ["KeyEvents"],
    }),
    keyEventControllerDeleteKeyEvent: build.mutation<
      KeyEventControllerDeleteKeyEventApiResponse,
      KeyEventControllerDeleteKeyEventApiArg
    >({
      query: queryArg => ({
        url: `/key-event/${queryArg.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["KeyEvents"],
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as generatedApi }

// Export hooks
export const {
  useKeyEventControllerCreateKeyEventMutation,
  useKeyEventControllerGetAllKeyEventsQuery,
  useKeyEventControllerUpdateKeyEventMutation,
  useKeyEventControllerDeleteKeyEventMutation,
} = injectedRtkApi

// Re-export types that are needed by components
export type {
  KeyEventDto,
  CreateKeyEventDto,
  UpdateKeyEventDto,
} from "./types/key-events.types"
